import { Button } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import React from 'react';

import styles from '@lmt/unicorn-shared/app/components/screen-plugs/StartErrorPage.module.scss';

type Props = {
  title: string;
  text: string;
  logoIconComponent?: React.ReactNode;
  rainbowIconComponent?: React.ReactNode;
  button?: { title: string; onClick: () => void };
};

const StartErrorPage: React.FC<Props> = React.memo(function StartErrorPage(
  props: Props,
) {
  const { logoIconComponent, rainbowIconComponent } = props;
  return (
    <div className={styles.container} data-test-id="start-error-container">
      <div className={styles.rainbowLeft}>{rainbowIconComponent}</div>
      <div className={styles.info}>
        <div className={styles.message}>
          <div className={styles.title} data-test-id="start-error-title">
            {props.title}{' '}
          </div>
          <div className={styles.text} data-test-id="start-error-text">
            {props.text}
          </div>
          {props.button && (
            <Button
              className={styles.button}
              title={props.button.title}
              onClick={props.button.onClick}
              testId="switch-tab-button"
            />
          )}
        </div>
        <div className={styles.logo}>{logoIconComponent}</div>
      </div>
      <div className={styles.rainbowRight}>{rainbowIconComponent}</div>
    </div>
  );
});
export default StartErrorPage;
